import React from 'react';
import { Typography } from '@material-ui/core';
import { CAT_BLACK, CAT_YELLOW } from './utils/styles';

export default function FooterSection(){
    return(
      <div style={{ background: CAT_BLACK, padding: '32px 24px', textAlign: 'center' }}>
        <Typography style={{ color: '#757575', fontSize: 13 }}>
          Need help? Contact the Helios team at{' '}
          <a href="mailto:Service_Adoption_Team_Cosmos@cat.com" style={{ color: CAT_YELLOW }}>
            Service_Adoption_Team_Cosmos@cat.com
          </a>
        </Typography>
      </div>
    );
}